/**
 * CreatingTournament i18n exports
 */
import { creatingTournamentTranslations as en } from './en';

export const translations = {
  en,
};

export type SupportedLocale = keyof typeof translations;

/**
 * Get translations for a given locale
 */
export const getTranslations = (locale: SupportedLocale = 'en') => {
  return translations[locale] || translations.en;
};

export { en };
